<div class="nc-root">
  <div class="nc-container">
    <!-- Input shell -->
    <div class="nc-shell">
      <textarea
        #chatInput
        class="nc-textarea"
        [(ngModel)]="currentPrompt"
        [disabled]="isLoading"
        placeholder="How can I help you today?"
        rows="2"
        (keydown.enter)="!$event.shiftKey && sendMessage(); !$event.shiftKey && $event.preventDefault()">
      </textarea>

      <div class="nc-shell-row">
        <div class="nc-shell-actions">
          <div class="nc-mode-toggle">
            <button
              type="button"
              class="nc-mode-btn"
              [class.nc-mode-btn--active]="mode === 'snapshot'"
              (click)="setMode('snapshot')">
              Snapshot
              <span class="nc-tooltip">{{ modeTooltips.snapshot }}</span>
            </button>
            <button
              type="button"
              class="nc-mode-btn"
              [class.nc-mode-btn--active]="mode === 'deepresearch'"
              (click)="setMode('deepresearch')">
              Deep research
              <span class="nc-tooltip">{{ modeTooltips.deepresearch }}</span>
            </button>
          </div>

          <button
            type="button"
            class="nc-send-btn"
            aria-label="Send"
            [disabled]="isLoading || !currentPrompt?.trim() || isAtLimit()"
            (click)="sendMessage()">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round">
              <line x1="12" y1="19" x2="12" y2="5" />
              <polyline points="5 12 12 5 19 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- A: contextual usage caption for the active mode. Clicking the text
           opens the chat usage indicator popover (per-type credit breakdown). -->
      <div *ngIf="showUsageCaption()" class="nc-usage-caption" [ngClass]="usageColorClass()">
        <app-chat-usage-indicator displayMode="caption">
          <ng-container *ngIf="!isAtLimit()">
            {{ activeRemaining() | number }} of {{ activeLimitValue() | number }}
            {{ modeLabel(mode) }} queries left
          </ng-container>
          <ng-container *ngIf="isAtLimit()">You're out of {{ modeLabel(mode) }} queries.</ng-container>
        </app-chat-usage-indicator>
        <a *ngIf="isAtLimit()" class="nc-usage-link" (click)="goToBilling()">Get more</a>
      </div>

      <!-- A': unlimited caption for the active mode -->
      <div *ngIf="showUnlimitedCaption()" class="nc-usage-caption">
        <app-chat-usage-indicator displayMode="caption">
          Unlimited {{ modeLabel(mode) }} queries
        </app-chat-usage-indicator>
      </div>
    </div>

    <!-- Pills -->
    <div class="nc-pills">
      <button
        *ngFor="let pill of visiblePills; trackBy: trackByPillKey"
        type="button"
        class="nc-pill"
        [class.nc-pill--active]="openCategory === pill.key"
        (click)="handlePillClick(pill.key)">
        {{ pill.label }}
      </button>
      <button type="button" class="nc-more-btn" (click)="toggleExpanded()">
        {{ expanded ? 'Show less ▲' : 'More (' + hiddenCount + ') ▼' }}
      </button>
    </div>

    <!-- Examples panel -->
    <div class="nc-panel" [class.nc-panel--open]="!!openCategory">
      <div class="nc-panel-inner" *ngIf="activeCategory as cat">
        <div class="nc-panel-header">
          <span class="nc-panel-title">{{ cat.label }}</span>
          <button type="button" class="nc-panel-close" aria-label="Close" (click)="closeCategory()">
            ✕
          </button>
        </div>
        <div class="nc-examples">
          <div
            *ngFor="let ex of exampleRungs; let i = index"
            class="nc-example"
            (click)="handleExampleClick(ex, i)">
            <div class="nc-example-label">{{ ex.label }}</div>
            <div class="nc-example-text">{{ ex.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
